import { ErrorHandler, Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private isHandlingError = false;
  private hasAttemptedTokenRefresh = false;

  constructor(
    private sessionService: SessionService,
    private afAuth: AngularFireAuth
  ) {
    // Reset token refresh flag periodically (every 5 minutes)
    setInterval(() => { this.hasAttemptedTokenRefresh = false; }, 5 * 60 * 1000);
  }

  async handleError(error: any): Promise<void> {
    if (this.isHandlingError) {
      return;
    }

    try {
      this.isHandlingError = true;

      // Log the error to console only
      console.error('Unhandled error:', error);

      // Handle session-related errors (token expiry)
      if (this.sessionService.isSessionError(error)) {
        if (!this.hasAttemptedTokenRefresh) {
          this.hasAttemptedTokenRefresh = true;
          try {
            const user = await this.afAuth.currentUser;
            if (user) {
              await user.getIdToken(true);
              return;
            }
          } catch (refreshError) {
            // Token refresh failed, fall through to session expiration
          }
        }
        this.sessionService.handleSessionExpiration();
      }
    } finally {
      this.isHandlingError = false;
    }
  }
}